import PageHeader from "../common/pageHeader/v2";
import About from "../components/section/about/v2";
import HowToMint from "../components/section/howToMint";
import Counter from "../components/section/counter";
import Team from "../components/section/team/v2";

const AboutPage = () => {
  return (
    <>
      <PageHeader title="about" subTitle="about us" />
      <About />
      <HowToMint />
      <Counter />
      <Team />
    </>
  );
};

export default AboutPage;
